<template>
    <activation-brief-provider
        v-slot="{
            brief,
            contact,
            isLoading,
            isPreview,
            errorMessage,
        }">
        <activation-brief-view
            :brief="brief"
            :contact="contact"
            :is-preview="isPreview"
            :is-loading="isLoading"
            :error-message="errorMessage"
        />
    </activation-brief-provider>
</template>

<script>
    import ActivationBriefProvider from '../providers/ActivationBriefProvider';
    import ActivationBriefView from '../data-views/activation-briefs/ActivationBriefView';

    export default {
        name:       'ActivationBriefRouterView',
        components: {
            ActivationBriefView,
            ActivationBriefProvider,
        },
    };
</script>
